export enum NetworkModalFilters {
  TRUSTED = 1,
  TRUSTING = 2
}
